<template>
    <BalancedHeader class="items-center py-2 px-4 font-medium text-md">
        <div
            class="truncate text-neutral-base content-lg-ux-medium text-center"
        >
            <slot />
        </div>
        <template #right>
            <slot name="right">
                <button
                    type="button"
                    class="appearance-none w-[32px] h-[38px] ml-2 flex items-center justify-center rounded-full cursor-pointer"
                    aria-label="Close"
                    @click="emit('close')"
                >
                    <PhIcon
                        icon="x"
                        weight="bold"
                        :size="20"
                    />
                </button>
            </slot>
        </template>
    </BalancedHeader>
</template>

<script setup>
    const emit = defineEmits(['close'])
</script>
